/*============================================================================
  Pub Sub
    Global publish / subscribe event system
============================================================================*/

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  cartError: 'cart-error',

  optionValueSelectionChange: 'option-value-selection-change'
};

let subscribers = {};


/**
 * Subscribe to event
 * @param {string} eventName 
 * @param {function} callback 
 * @returns {function} Unsubscribe function
 */
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined){
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

/**
 * Publish event to all subscribers
 * @param {string} eventName 
 * @param {*} data 
 * @returns {Promise} Resolves when all subscribers finish
 */
function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
      .filter((result) => result instanceof Promise);

    return Promise.all(promises);
  }

  return Promise.resolve();
}


/*
  Event data structure:
    - cart-update: { source: 'product-form', productVariantId: formData.get('id'), cartData: response }
    - cart-error: { source: 'product-form', response: response }
    - option-value-selection-change: { data: { event, target, selectedOptionValues: this.selectedOptionValues }}
*/
